import { render } from "./TimerInstance.vue?vue&type=template&id=14569bce"
import script from "./TimerInstance.vue?vue&type=script&lang=js"
export * from "./TimerInstance.vue?vue&type=script&lang=js"
script.render = render

export default script